export const FIELD_MAPPINGS = {
  period: 'periodName',
  bsmaccount: 'bsmAccount',
  glaccount: 'glAccount',
};

export const MIN_COLUMNS_NUMBER = 3;
export const MAX_COLUMNS_NUMBER = 3;
